import { render, staticRenderFns } from "./Subs01Modal.vue?vue&type=template&id=2d95e9a4&scoped=true&"
import script from "./Subs01Modal.vue?vue&type=script&lang=ts&"
export * from "./Subs01Modal.vue?vue&type=script&lang=ts&"
import style0 from "./Subs01Modal.vue?vue&type=style&index=0&id=2d95e9a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d95e9a4",
  null
  
)

export default component.exports